import { render, staticRenderFns } from "./sidebar-proofitem.vue?vue&type=template&id=1f4a56b4&scoped=true&"
import script from "./sidebar-proofitem.vue?vue&type=script&lang=js&"
export * from "./sidebar-proofitem.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-proofitem.vue?vue&type=style&index=0&id=1f4a56b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4a56b4",
  null
  
)

export default component.exports